import { render, staticRenderFns } from "./depperbusdafi.vue?vue&type=template&id=4332e565&scoped=true&"
import script from "./depperbusdafi.vue?vue&type=script&lang=js&"
export * from "./depperbusdafi.vue?vue&type=script&lang=js&"
import style0 from "./depperbusdafi.vue?vue&type=style&index=0&id=4332e565&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4332e565",
  null
  
)

export default component.exports